import {useQuery} from '@tanstack/react-query'
import {ApiUrls} from "../config/urls";
import axios from "axios";

export function useUser(email, language, forceRefresh) {
    const url =  ApiUrls.CUSTOMER.replace('{email}', email).replace('{lng}', language);

    let options = {
        queryKey: [url],
        refetchOnWindowFocus: "always",
        cacheTime: Infinity,
        staleTime: import.meta.env.VITE_REACT_QUERY_USER_STALE_TIME*1,
        enabled: Boolean(email) && axios.defaults.headers.common.hasOwnProperty('X-Auth-Token')
    };

    if (forceRefresh) {
        options.staleTime = 0;
    }

    return useQuery(options);
}